import { isLocal } from './environments';

export const LOCAL_DEV_TOKEN_STORAGE_KEY = 'uam:local-dev-token';

/**
 * Allow Bearer override on `next dev` even when NEXT_PUBLIC_ENV is staging/development.
 * Never on production builds.
 */
export function isLocalDevTokenAllowed(): boolean {
  return process.env.NODE_ENV === 'development' || isLocal();
}

/**
 * Dev-only Bearer override for MyAccess/UAM API calls when Auth lib proxy is unavailable.
 * Priority: localStorage → NEXT_PUBLIC_LOCAL_DEV_TOKEN
 * Does not affect EIB (which keeps NEXT_PUBLIC_EIB_LOCAL_DEV_TOKEN via getEibHeaders).
 */
export function getLocalDevToken(): string | null {
  if (!isLocalDevTokenAllowed()) {
    return null;
  }

  if (typeof window !== 'undefined') {
    const fromStorage = window.localStorage
      .getItem(LOCAL_DEV_TOKEN_STORAGE_KEY)
      ?.trim();

    if (fromStorage) {
      return fromStorage;
    }
  }

  return process.env.NEXT_PUBLIC_LOCAL_DEV_TOKEN?.trim() || null;
}

export function setLocalDevToken(token: string): void {
  if (!isLocalDevTokenAllowed() || typeof window === 'undefined') {
    return;
  }

  const trimmed = token.trim();
  if (!trimmed) {
    return;
  }

  window.localStorage.setItem(LOCAL_DEV_TOKEN_STORAGE_KEY, trimmed);
}

export function clearLocalDevToken(): void {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.removeItem(LOCAL_DEV_TOKEN_STORAGE_KEY);
}

export function hasLocalDevTokenOverride(): boolean {
  return Boolean(getLocalDevToken());
}
